import styled from "styled-components";

export const ContainerRefreshQrCode = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fbfbfd;
  border: 1px dashed #616161;
  padding: 24px;
  flex-direction: column;
  transition: background 0.3s;
  cursor: pointer;
  &:hover {
    background: #f0f1f3;
  }
`;
